import React, { useEffect, useMemo } from 'react';
import { HolidayApprovalsHeader } from "./components/HolidayApprovalsHeader";
import styled from "styled-components";
import { ApprovalsCalendarList } from "./components/ApprovalsCalendarList";
import { useSelector } from "react-redux";
import { selectCalendarDate } from '@shared/store/dashboard.duck';
import Colours from '@shared/ui/atoms/Colours';
import { ApprovalsUserSectionHeader } from "./components/ApprovalsUserSectionHeader";
import { ApprovalsList } from "./components/ApprovalsList";
import { selectIsApprovalsLoading } from '@features/holidays/store/approvalRequests.duck';
import { Center } from '@shared/ui/atoms/StructuralLayout';
import { LoadingSpinner } from '@shared/ui/atoms/LoadingSpinner';
import { tablet } from '@shared/ui/atoms/MediaQueries';
import { WorkPlannerLayout } from '@shared/ui/molecules/work-planner/WorkPlannerLayout';
import { selectCurrentUser } from '@shared/store/auth.duck';
import { ApprovalsNotEnabled } from "./components/ApprovalsNotEnabled";
import { selectConfig } from '@shared/store/config.duck';
import moment from "moment";

export default function HolidayApprovalsView() {
  const calendarDate = useSelector(selectCalendarDate);
  const isLoading = useSelector(selectIsApprovalsLoading);
  const currentUser = useSelector(selectCurrentUser);
  const config = useSelector(selectConfig);

  const holidayYearStartDate = useMemo(() => {
    const startDate = config.getHolidayYearStartDate().clone();
    startDate.year(calendarDate.year());
    return startDate;
  }, [calendarDate, config]);

  const holidayYearEndDate = useMemo(() => {
    const endDate = config.getHolidayYearEndDate(holidayYearStartDate.clone())?.clone() || moment();
    return endDate;
  }, [holidayYearStartDate, config]);

  useEffect(() => {
    // Get elements and necessary element heights
    const contentDiv = document.getElementById("content");

    // Get view height
    const viewportHeight = document.getElementsByTagName('body')[0].clientHeight;

    // Compute the content height - we want to fill the whole remaining area
    // in browser window
    if (contentDiv && viewportHeight) {
      contentDiv.style.height = `${viewportHeight - contentDiv.offsetTop}px`;
    }
  }, []);

  const areApprovalsEnabled = currentUser?.companyEntity.holidayApprovalEnabled;

  return (
    <WorkPlannerLayout pageContentStyles={{paddingTop: 24}} numberOfWeeksInMonth={6}>
      {areApprovalsEnabled ? <>
        <HolidayApprovalsHeader holidayYearStartDate={holidayYearStartDate} />
        <ApprovalsBody id={'content'}>
          <Content>
            <ApprovalsUserSectionHeader holidayYearStartDate={holidayYearStartDate} holidayYearEndDate={holidayYearEndDate} />

            <ApprovalsList />
            {isLoading && <Center><LoadingSpinner hideText={true} hideBorder={true} /></Center>}
          </Content>
          <Sidebar>
            <ApprovalsCalendarList holidayYearStartDate={holidayYearStartDate} />
          </Sidebar>
        </ApprovalsBody>
      </> : <>
        <ApprovalsNotEnabled />
      </>}
    </WorkPlannerLayout>
  )
}

const Content = styled.div`
  flex: 1;
  height: 100%;
  overflow-y: auto;
`

const Sidebar = styled.div`
  display: none;
  height: 100%;
  min-width: 200px;
  overflow-y: auto;
  border-left: solid 1px ${Colours.mildGrey};

  @media (${tablet}) {
    display: block;
  }
`

const ApprovalsBody = styled.div`
  display: flex;
`
